import "cleave.js/dist/addons/cleave-phone.sg";
import React from "react";
import BannerBG from "../components/BannerComponents/BannerBG";
import Form from '../components/BookingForm';

function BookingForm(props) {

  return (
    <div>
      <BannerBG bannerBG='defaultBannerBG'>
        <div className='banner3'>
          <Form/>
        </div>
      </BannerBG>
    </div>
  );
}

  export default BookingForm
  